import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import ProductCollapseDesktop from '../../mis-compras/components/desktop/ProductCollapseDesktop';
import TicketDetail from './TicketDetail';

import { getTicketImage } from '../../../../redux/actions/TicketActions';

const Ticket = ({ ...props }) => {
  const { index, mobile, ticket } = props;
  const {
    fecha_ingreso,
    isMkp,
    motiveName,
    name,
    thumbnailImage,
    ticketId,
    typeName,
    sku,
  } = ticket;
  const dispatch = useDispatch();
  const [mouseOver, setMouseOver] = useState(false);

  const handleIsOpen = (event) => {
    if (event === 'panel1' && !thumbnailImage) dispatch(getTicketImage(sku));
  };

  return (
    <Box
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
    >
      <ProductCollapseDesktop
        key={index}
        mobile={mobile}
        name={motiveName}
        purchaseDate={fecha_ingreso}
        index={index}
        isMkp={isMkp}
        dateText="Fecha de ingreso:"
        isOpen={handleIsOpen}
        data-cy={`ticketCollapse-${index}`}
        mouseOver={mouseOver}
      >
        <TicketDetail
          thumbnailImage={thumbnailImage}
          name={name}
          ticketId={ticketId}
          typeName={typeName}
          motiveName={motiveName}
          index={index}
        />
      </ProductCollapseDesktop>
    </Box>
  );
};

Ticket.propTypes = {
  index: PropTypes.number,
  mobile: PropTypes.bool,
  ticket: PropTypes.object,
};

export default Ticket;
